import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';

import './PrivateRoutes.css';

const PrivateRoutes = () => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <div>
      <Sidebar />
      <main className="private-routes-main">
        <Outlet />
      </main>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoutes;